export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  appVersion: import.meta.env.VITE_APP_VERSION ?? 'dev',
} as const
